
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			sheetLines: ["70%", "90%", "55%", "85%", "40%"]
		};
	},
	props: {
		text: String
	}
});
